<div class='moveRecord selfRadius' *ngIf='record.length>0'>
  <div>
    <span class='title'>{{ title }}</span>
  </div>
  <ng-container *ngFor='let item of record'>
    <div class='flexRow info-item flex-start mb-sm' *ngIf='isCreate'>
      <label class='label_title text-gray1'>{{ item['title'] }}：</label>
      <div class='pl-xs'>
        <span *ngIf="item['type']=='text'">{{ item['value']}}</span>
        <div style='width:120px;max-width: 120px;height: 90px;overflow:hidden' class='border-1 flexRow selfRadius'
          *ngIf="item['type']=='image'"><img src="{{ item['value']}}" class='store_image selfRadius' /></div>
      </div>
    </div>
    <div class='flexRow info-item flex-start mb-sm' *ngIf='!isCreate'>
      <label class='label_title text-gray1'>{{ item['title'] }}：</label>
      <div class="pl-xs flexRow {{item['align']}}" [ngStyle]="{'width':'824px'}">
        <div *ngIf="item['type']=='text'" class=' text-nowrap text-truncate d-inline-block' style='max-width:576px;'>{{
          item['value']['old']}}</div>
        <div style='width:120px;max-width: 120px;height: 90px;overflow:hidden' class='border-1 flexRow selfRadius'
          *ngIf="item['type']=='image'"><img src="{{ item['value']['old']}}" class='store_image selfRadius' /></div>
        <i nz-icon nzType='swap-right' nzTheme='outline' class='text-gray2' style='height:22px;line-height:24px;'></i>
        <div *ngIf="item['type']=='text'" class='  text-nowrap text-truncate d-inline-block' style='max-width:576px;'>{{
          item['value']['new']}}</div>
        <div style='width:120px;max-width: 120px;height: 90px;overflow:hidden' class='border-1 flexRow selfRadius'
          *ngIf="item['type']=='image'"><img src="{{ item['value']['new']}}" class='store_image selfRadius' /></div>
      </div>
    </div>
  </ng-container>
  <div class='text-gray3' *ngIf='objectKeys(data).length >2'>...</div>
</div>

<!---->